/**
 * Московское время в интерфейсе.
 *
 * Сервер живёт в UTC, рабочие сутки колл-центра — московские (спека §6.7).
 * Браузер диспетчера может стоять в любом часовом поясе, поэтому ни одна дата
 * в UI не форматируется локальной зоной: и «сегодня», и время звонка — всегда МСК.
 */

import { businessDay, businessDayBounds, MOSCOW_TZ } from '@cc/shared';

export { MOSCOW_TZ, businessDayBounds };

/** Текущие рабочие сутки в виде YYYY-MM-DD — ключ всех дневных экранов */
export function todayMsk(now: Date = new Date()): string {
  return businessDay(now);
}

/** YYYY-MM-DD → 25.08.2026 */
export function formatBusinessDate(businessDate: string): string {
  const [year, month, day] = businessDate.split('-');
  if (!year || !month || !day) return businessDate;
  return `${day}.${month}.${year}`;
}

const timeFormatter = new Intl.DateTimeFormat('ru-RU', {
  timeZone: MOSCOW_TZ,
  hour: '2-digit',
  minute: '2-digit',
});

const dateTimeFormatter = new Intl.DateTimeFormat('ru-RU', {
  timeZone: MOSCOW_TZ,
  day: '2-digit',
  month: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
});

/** 14:35 по Москве */
export function formatTimeMsk(at: Date | string): string {
  return timeFormatter.format(toDate(at));
}

/** 25.08 14:35 по Москве — для списков, где важна и дата */
export function formatDateTimeMsk(at: Date | string): string {
  return dateTimeFormatter.format(toDate(at));
}

/** «15:00» для сегодняшнего момента, с датой — для любого другого дня. */
export function formatWhenMsk(at: Date | string, now: Date = new Date()): string {
  const d = toDate(at);
  return todayMsk(d) === todayMsk(now) ? formatTimeMsk(d) : formatDateTimeMsk(d);
}

const fullDateTimeFormatter = new Intl.DateTimeFormat('ru-RU', {
  timeZone: MOSCOW_TZ,
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

/**
 * 25.08.2026 14:35 по Москве — там, где записи разнесены на годы.
 * История настройки как раз такая: между двумя правками порога дозвона проходит
 * год, и «10.01» без года не отвечает на вопрос «чем считался тот отчёт».
 */
export function formatFullDateTimeMsk(at: Date | string): string {
  return fullDateTimeFormatter.format(toDate(at));
}

function toDate(at: Date | string): Date {
  return at instanceof Date ? at : new Date(at);
}
